import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Facebook } from "lucide-react";
import { COMPANY } from "../data/site";
import Logo from "./Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#13263c] text-[#f7f4ec] mt-0"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 py-12 md:py-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-10">
          {/* Brand lockup */}
          <div className="flex-shrink-0" data-testid="footer-lockup">
            <Logo variant="inline-dark" size="md" testId="footer-logo" />
          </div>

          {/* Contact row */}
          <div className="flex flex-col md:flex-row md:items-center gap-5 md:gap-8 text-sm">
            <div className="flex items-center gap-2.5" data-testid="footer-location">
              <MapPin size={16} className="text-[#b8895a]" />
              <span className="uppercase tracking-[0.18em] text-xs md:text-sm">{COMPANY.location}</span>
            </div>
            <a href={COMPANY.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2.5 hover:text-[#b8895a] transition-colors">
              <Phone size={16} className="text-[#b8895a]" />
              <span className="tracking-wide">{COMPANY.phone}</span>
            </a>
            <a href={COMPANY.emailHref} data-testid="footer-email-link" className="flex items-center gap-2.5 hover:text-[#b8895a] transition-colors break-all">
              <Mail size={16} className="text-[#b8895a]" />
              <span>{COMPANY.email}</span>
            </a>
          </div>

          {/* Right cluster */}
          <div className="flex flex-col md:flex-row md:items-center gap-5 md:gap-8">
            <div className="flex items-center gap-6 text-xs uppercase tracking-[0.2em]">
              <Link to="/faq" data-testid="footer-link-faq" className="hover:text-[#b8895a] transition-colors">FAQ</Link>
              <Link to="/contact" data-testid="footer-link-contact" className="hover:text-[#b8895a] transition-colors">Contact</Link>
              <a
                href={COMPANY.reviewUrl}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="footer-review-link"
                className="hover:text-[#b8895a] transition-colors underline underline-offset-4 decoration-[#b8895a]/40"
              >
                Review Us
              </a>
            </div>
            <div className="flex items-center gap-4 md:pl-4 md:border-l md:border-[#1f3a5a]">
              <a
                href={COMPANY.instagramUrl}
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Instagram"
                data-testid="footer-instagram-link"
                className="hover:text-[#b8895a] transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href={COMPANY.facebookUrl}
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Facebook"
                data-testid="footer-facebook-link"
                className="hover:text-[#b8895a] transition-colors"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        <hr className="border-0 h-px bg-[#1f3a5a] mt-10" />
        <p
          data-testid="footer-copyright"
          className="text-center mt-6 text-xs tracking-[0.18em] uppercase text-[#9aa9bc]"
        >
          © {year} Gateway Boat Co. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
